import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import AddForm from './Viewall'
import { Box } from '@chakra-ui/react';

const View = () => {
    return (
        <div>
            <HeaderSection
                title="Expense Voucher"
                breadcrumb={["Dashboard", "Voucher", "Expense List"]}
            />
            <Box p={6}>

                <AddForm />
            </Box>
        </div>
    )
}

export default View